<script lang="ts">
  import Increase from "../../../icons/Increase.svg"
  import Decrease from "../../../icons/Decrease.svg"

  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"

  import { recommendation } from "../../../stores/recommendation"

  import IconButton from "../../Common/IconButton.svelte"

  export let product: RecommendationProduct

  let quantity = 0

  $: updateShowQuantity(product.quantity)

  function updateShowQuantity (newQuantity: number) {
    quantity = newQuantity
  }

  const quantityMin = 1
  const quantityMax = 9999

  function handleDecreaseButtonOnClick () {
    if (quantity > quantityMin) {
      quantity--
    }
    recommendation.updateProductQuantity(product.id, quantity)
  }

  function handleIncreaseButtonOnClick () {
    if (quantity < quantityMax) {
      quantity++
    }
    recommendation.updateProductQuantity(product.id, quantity)
  }
  function handleQuantityInputOnChange() {
    if (quantity > quantityMax) {
      quantity = quantityMax
    }
    if (quantity < quantityMin) {
      quantity = quantityMin
    }

    recommendation.updateProductQuantity(product.id, quantity)
  }
</script>

<div class="quantity-selector">
  <!-- <QuantitySelector
    bind:value={quantity}
    on:change={handleQuantityOnChange}
  /> -->
  <IconButton
    icon={Decrease}
    label="Decrease Product Quantity"
    on:click={handleDecreaseButtonOnClick}
    disabled={product.quantity === 1}
  />
  <input
    aria-label={`${product.name} Product Quantity`}
    class="quantity-selector-input"
    maxlength=4
    bind:value={quantity}
    on:change={handleQuantityInputOnChange}
  />
  <IconButton
    icon={Increase}
    label="Increase Product Quantity"
    on:click={handleIncreaseButtonOnClick}
  />
</div>

<style lang="scss">
  .quantity-selector {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    padding: 0 16px;

    .quantity-selector-input {
      background: transparent;
      border: none;
      text-align: center;
      width: calc(100% - 64px);
    }
  }
</style>
